<div class="container">
    <div class="card" *ngFor="let item of catLogData; let i = index">
        <div class="card-body card-text-minimise card-body-wrap" (click)="clickOnCard(item['brandKey'])">
            <img class="card-img-top" [src]="item['imageUrls']['1200w-326ppi']" alt="Card image" style="width:100%">
            <h4 class="card-title">{{item.brandName}}</h4>
            <p class="card-text" [innerHTML]="item.description"></p>
            
        </div>
        <div class="disclaimer-icon" (click)="clickOnDisclaimer(item['disclaimer'])">
            <span>Disclaimer : </span><img src="assets/images/disclaimer.png" alt="disclaimer" width="20" height="20">
        </div>
        <div class="d-flex justify-content-between p-3">
            <a href="javascript:void(0)" class="btn btn-primary order-button" [class.button-dis]="item['brandKey'] != isChecked"
                (click)="clickOnOrder(item['brandKey'],item['items'][0]['utid'])">Order</a>
            <input type="checkbox" [(ngModel)]="item['brandKey'] == isChecked" name="checkbox-{{i}}"
                id="txt-check-{{i}}" class="cursor-not-allowed checkbox-field" [disabled]="item['brandKey'] != isChecked">
        </div>
    </div>
    <div class="modal fade newsletter-modal" [ngClass]="{'show': isModalOpen}"
        [style.display]="isModalOpen ? 'block' : 'none'" [style.opacity]="isModalOpen ? '1' : '0'" tabindex="-1"
        role="dialog">
        <div class="modal-dialog newsletter-block" role="document">
            <div class="modal-content">
                <div class="modal-header header-modal-title-wrp">
                    <h5 class="modal-title header-modal-title">Enter And Verify Email</h5>
                    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
                        <span aria-hidden="true" class="close-icon">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form *ngIf="!isOtpShow">
                        <div class="form-group">
                            <label for="email">Email address</label>
                            <input type="email" class="form-control" id="email" placeholder="Enter your email" (input)="onEmailInput($event)">
                            <p *ngIf="emailError != ''" style="color: red;">{{emailError}}</p>
                        </div>
                        <div class="model-buttons">
                            <button type="button" class="btn btn-primary submit-modal-btn" (click)="submitEmail()">Submit</button>
                        </div>
                    </form>

                    <form *ngIf="isOtpShow">
                        <div class="form-group">
                            <label for="otp">Verify OTP</label>
                            <input type="email" class="form-control" id="otp" placeholder="Enter your otp" (input)="onOtpInput($event)">
                        </div>
                        <div class="model-buttons">
                            <button type="button" class="btn btn-secondary" (click)="cancelModal()">cancel</button>
                            <button type="button" class="btn btn-primary ml-3" (click)="varifyOtp()">Verify and Get Reward</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade newsletter-modal" [ngClass]="{'show': isDisclaimerOpen}"
        [style.display]="isDisclaimerOpen ? 'block' : 'none'" [style.opacity]="isDisclaimerOpen ? '1' : '0'" tabindex="-1"
        role="dialog">
        <div class="modal-dialog newsletter-block" role="document">
            <div class="modal-content">
                <div class="modal-header header-modal-title-wrp">
                    <h4 class="modal-title header-modal-title">Disclaimer</h4>
                    <button type="button" class="close" (click)="closeDisclaimer()" aria-label="Close">
                        <span aria-hidden="true" class="close-icon">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p [innerHTML]="disclaimerText"></p>
                </div>
            </div>
        </div>
    </div>
</div>